import { styled } from "styled-components";
import theme from "../../styles/theme";
import { useEffect, useState } from "react";
import CommonDataGrid from "../common/CommonDataGrid";
import AnnouncementIcon from '@mui/icons-material/Announcement';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";
import { useGetNotice } from "../../interfaces/dashboard";

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        span {
            font-size:1.4rem;
            font-weight: 600;
            color: #e2614d;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
        }
    }
`;
const NoticeTitle = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        font-size: 1.3rem;
        font-weight: 600;
        // height: 2.5rem;
        font-weight: 600;
        display: grid;
        grid-template-columns: 10rem 25rem 20rem minmax(1rem,auto);
        span {
            display: inline-block;
        }
        border-bottom: 2px solid #e2614d;
    }
`;
const NoticeList = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    margin-top: 0.6rem;
    background: #efeeea;
    .slick-dots {
        bottom: -2.5rem;
    }
`
const NoticeLi = styled.li`
    // line-height: 2rem;
    font-size: 1.3rem;
    // height: 2rem;
    display: grid !important;
    grid-template-columns: 10rem 25rem 20rem minmax(1rem,auto);
    span {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`

const columns = [
    { field: 'reg_dt', headerName: '작성일시', width: 160, headerAlign:'center' },
    { field: 'project_nm', headerName: '과업명', width: 240, headerAlign:'center' },
    { field: 'client_nm', headerName: '발주처', width: 120, headerAlign:'center' },
    { field: 'descr', headerName: '내용', flex:1, headerAlign:'center', align:'center' },
]

const Notice = () => {

    const [list, setList] = useState([
        // {id:1,reg_dt:'2023-11-20 13:01:02',project_nm:'가평군 보행량조사',client_nm:'에스원엔지니어링',descr:'월요일까지'},
        // {id:2,reg_dt:'2023-11-20 13:01:02',project_nm:'은명초교 인근 교통량조사',client_nm:'건영이앤씨',descr:'화요일까지'},
        // {id:3,reg_dt:'2023-11-13 13:01:02',project_nm:'청주 서원보건소 일대 3개소 및 유출입조사',client_nm:'서하이앤씨',descr:'월요일까지'},
    ]);

    const {data} = useGetNotice();

    const setting = {
        infinite: true,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows:false,
        // vertical: true,
        dots: true
    }

    useEffect(()=>{
        data && setList(data)
    },[data])

    return (
        <MainWrap>
            <div className="title_line"><span><AnnouncementIcon />공지/알림</span><MoreVertIcon /></div>
            <div style={{width:'100%',height:'calc(100% - 3rem)',background:'#efeeea',padding:'1rem 1rem', boxSizing:'border-box'}}>
                <NoticeTitle>
                    <li>
                        <span>작성일시</span>
                        <span>과업명</span>
                        <span>발주처</span>
                        <span>내용</span>
                    </li>
                </NoticeTitle>
                <NoticeList>
                    <Slider {...setting}>
                        {list && list.map((item,index)=>{
                        return (<NoticeLi key={index}>
                            <span>{moment(item.set_to).format('YYYY-MM-DD')}</span>
                            <span>{item.title}</span>
                            <span>{item.cname}</span>
                            <span>{item.alert_msg}</span>
                        </NoticeLi>)
                        })}
                    </Slider>
                </NoticeList>
            </div>
            {/* <Slider {...setting}>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>파주운정3택지개발지구 6개소(유턴포함)ddddsdfasdfasddddddd</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>6666666</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>99999</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    </Slider> */}
        </MainWrap>
    )
}

export default Notice;
